import { useDispatch, useSelector } from "react-redux";
import { axiosInstance } from "../auth";

const keyType = "gallery";
const perpage = 15;

export const UPDATE_FIELD = `${keyType}UpdateField`;
export const SET_LIST = `${keyType}SetList`;

export const SET = "gallerySet";
export const SET_LOADING = "galleryLoading";
export const CLEAR = "galleryClear";

export const updateFields = ({ prop, value }) => ({
  type: UPDATE_FIELD,
  payload: { prop, value },
});

export const useGallery = () => {
  const gallery = useSelector((state) => state.gallery);
  const dispatch = useDispatch();
  return {
    ...gallery,
    dispatch,
    listSearch,
    getList,
    submittAddFile,
    submittUpdateFile,
    getCollections,
    submittDeleteFile,
    toggleGallery,
    getItem,
  };
};

export const getItem = (id, cb) => async (dispatch, getState) => {
  try {
    const result = await axiosInstance.get(`/media-panel/${id}`);
    cb(result.data);
  } catch (e) {}
};

export const toggleGallery = (handleSelectFile) => async (
  dispatch,
  getState
) => {
  try {
    const {
      gallery: { showGallery },
    } = getState();

    dispatch({
      type: SET,
      payload: { handleSelectFile, showGallery: !showGallery },
    });
  } catch (e) {}
};

const searchFields = (key) => {
  // eslint-disable-next-line default-case
  switch (key) {
    case "media":
      return "translations.title";
  }
};

export const getList = (
  collection = undefined,
  search = undefined,
  page = 1
) => async (dispatch, getState) => {
  try {
    const {
      gallery: { list },
    } = getState();

    dispatch({
      type: SET_LOADING,
      payload: true,
    });

    dispatch(updateFields({ prop: "load", value: true }));

    let url = `/media-panel?page=${page}${
      collection ? `&&filter[type][$eq]=${collection}` : ``
    }`;

    if (search) {
      const match = url.match(/\/([^/-]+)(?:-panel)?/);
      const extractedValue = match ? match[1] : null;

      url = `${url}&search.fields=${searchFields(
        extractedValue
      )}&search.value=${search}`;
    } else {
      url = `/media-panel?page=${page}${
        collection ? `&&filter[type][$eq]=${collection}` : ``
      }`;
    }

    const result = await axiosInstance.get(url);

    dispatch({
      type: SET,
      payload: {
        list: page > 1 ? [...list, ...result.data.data] : result.data.data,
        loading: false,
        current_page: Number(result.data.meta.pagination.current_page),
        last_page: Number(result.data.meta.pagination.last_page),
        per_page: Number(result.data.meta.pagination.per_page),
        current_collection: collection ? collection : null,
        current_search: search !== undefined ? search : search,
      },
    });

    dispatch(
      updateFields({
        prop: "perPage",
        value: Number(result.data.meta.pagination.per_page),
      })
    );
    dispatch(updateFields({ prop: "load", value: false }));
  } catch (e) {
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
  }
};

export const listSearch = (searchKey) => async (dispath) => {
  dispath(updateFields({ prop: "searchKey", value: searchKey }));
  dispath(getList(undefined, searchKey, 1));
};

export const getCollections = () => async (dispatch) => {
  try {
    dispatch({
      type: SET,
      payload: { collectionLoading: true },
    });
    // const result = await axiosInstance.get("/core/media-collections");
    dispatch({
      type: SET,
      payload: {
        collections: [
          {
            lable: "همه",
            value: null,
          },
          {
            lable: "اخبار",
            value: "News",
          },
          {
            lable: "ویدیو",
            value: "Video",
          },
          {
            lable: "اسلایدر",
            value: "Slider",
          },
          {
            lable: "صفحه",
            value: "Show",
          },
          {
            lable: "لیگ",
            value: "League",
          },
          {
            lable: "بازی",
            value: "Match",
          },
          {
            lable: "بازیکن",
            value: "Player",
          },
          {
            lable: "تیم",
            value: "Team",
          },
        ],
        collectionLoading: false,
      },
    });
  } catch (e) {
    dispatch({
      type: SET,
      payload: { collectionLoading: false },
    });
  }
};

export const submittAddFile = (values, cb) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });
    const fd = new FormData();

    if (values?.image?.file) {
      fd.append("image", values.image.file);
    } else {
      fd.append("image", "null");
    }

    if (values?.video?.file) {
      fd.append("video", values.video.file);
    } else {
      fd.append("video", "null");
    }

    if (values?.audio?.file) {
      fd.append("audio", values.audio.file);
    } else {
      fd.append("audio", "null");
    }

    if (values.translations.fa.title) {
      fd.append("translations.fa.title", values.translations.fa.title);
    }

    if (values.type) {
      fd.append("type", values.type);
    }

    const result = await axiosInstance.post("/media-panel", fd);
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
    cb();
  } catch (e) {}
};

export const submittUpdateFile = (values, cb) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });
    const fd = new FormData();

    if (values?.image?.file) {
      fd.append("image", values.image.file);
    }

    if (values?.video?.file) {
      fd.append("video", values.video.file);
    }

    if (values?.audio?.file) {
      fd.append("audio", values.audio.file);
    }

    if (values.translations.fa.title) {
      fd.append("translations.fa.title", values.translations.fa.title);
    }

    if (values.translations.en.title) {
      fd.append("translations.en.title", values.translations.en.title);
    }

    if (values.translations.fa.summary) {
      fd.append("translations.fa.summary", values.translations.fa.summary);
    }

    if (values.translations.en.summary) {
      fd.append("translations.en.summary", values.translations.en.summary);
    }

    if (values.type) {
      fd.append("type", values.type);
    }

    const result = await axiosInstance.put(`/media-panel/${values.id}`, fd);
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
    cb();
  } catch (e) {}
};

export const submittDeleteFile = (id, cb) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });

    const result = await axiosInstance.delete(`/media-panel/${id}`);
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
    cb();
  } catch (e) {}
};
